export { generateDropdownOptionsForCurrencies } from '../discounts';

export const generateEditLinkForExchangeRate = id => `/exchangeRates/edit?rateID=${id}`;

export const generateInitialValues = searchConfig => ({
    currencyId: searchConfig.currencyId,
    dateFrom: searchConfig.dateFrom,
    dateTo: searchConfig.dateTo,
});